

// import React, { useState, useEffect } from "react";
// import Navbar from "../../../Patient/components/pages/Navbar";
// import { Container, Row, Col, Form, Card, Button, Modal } from "react-bootstrap";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faSearch, faMapMarkerAlt, faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import profile from "./image/dp.png";
// import "./SearchDoctor.css";
// import Footer from "../../../Footer/Footer";
// import BookingModal from "./BookingModal";

// import { getDatabase, ref, get } from "firebase/database";
// import { app } from "../../../Doctor/Firebase/firebase.config";

// const database = getDatabase(app);

// /* ================= CITY NORMALIZER ================= */
// const normalizeCity = (text = "") =>
//   text.toLowerCase().split(",")[0].trim();

// export default function SearchDoctor() {
//   const [doctors, setDoctors] = useState([]);
//   const [locality, setLocality] = useState("");
//   const [doctorName, setDoctorName] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [searched, setSearched] = useState(false);
//   const [selectedDoctor, setSelectedDoctor] = useState(null);
//   const [mapLoaded, setMapLoaded] = useState(false);
//   const [showBookingModal, setShowBookingModal] = useState(false);
//   const [bookingDoctor, setBookingDoctor] = useState(null);

//   /* ================= LOAD GOOGLE MAPS ================= */
//   useEffect(() => {
//     if (window.google && window.google.maps) {
//       setMapLoaded(true);
//       return;
//     }

//     const script = document.createElement("script");
//     script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&libraries=places&loading=async`;
//     script.async = true;
//     script.defer = true;
//     script.onload = () => setMapLoaded(true);
//     script.onerror = () => toast.error("Google Maps failed to load");

//     document.head.appendChild(script);
//   }, []);

//   /* ================= SAFE AUTOCOMPLETE ================= */
//   useEffect(() => {
//     if (!mapLoaded) return;

//     let retry;

//     const initAutocomplete = () => {
//       if (
//         window.google &&
//         window.google.maps &&
//         window.google.maps.places
//       ) {
//         const input = document.getElementById("locality-input");
//         if (!input) return;

//         const autocomplete =
//           new window.google.maps.places.Autocomplete(input, {
//             types: ["(cities)"],
//             componentRestrictions: { country: "in" },
//           });

//         autocomplete.addListener("place_changed", () => {
//           const place = autocomplete.getPlace();
//           setLocality(place.formatted_address || place.name || "");
//         });
//       } else {
//         retry = setTimeout(initAutocomplete, 100);
//       }
//     };

//     initAutocomplete();
//     return () => clearTimeout(retry);
//   }, [mapLoaded]);

//   /* ================= FETCH DOCTORS ================= */
//   const fetchDoctors = async () => {
//     const searchName = doctorName.trim().toLowerCase();
//     const searchCity = normalizeCity(locality);

//     if (!searchName && !searchCity) {
//       toast.warning("Please enter doctor name or locality");
//       return;
//     }

//     try {
//       setLoading(true);
//       setSearched(true);

//       const doctorsRef = ref(database, "doctor");
//       const snapshot = await get(doctorsRef);

//       if (!snapshot.exists()) {
//         setDoctors([]);
//         return;
//       }

//       const data = snapshot.val();

//       const allDoctors = Object.keys(data).map((key) => ({
//         id: key,
//         ...data[key],
//       }));

//       const filtered = allDoctors.filter((doctor) => {
//         const first = doctor.First?.toLowerCase() || "";
//         const last = doctor.Last?.toLowerCase() || "";
//         const speciality = doctor.Speciality?.toLowerCase() || "";

//         const doctorCity = normalizeCity(doctor.Locality);
//         const doctorAddress =
//           doctor.ClinicAddress?.toLowerCase() || "";

//         const nameMatch =
//           !searchName ||
//           first.includes(searchName) ||
//           last.includes(searchName) ||
//           speciality.includes(searchName);

//         const locationMatch =
//           !searchCity ||
//           doctorCity.includes(searchCity) ||
//           doctorAddress.includes(searchCity);

//         return nameMatch && locationMatch;
//       });

//       setDoctors(filtered);
//     } catch (err) {
//       console.error(err);
//       toast.error("Failed to fetch doctors");
//     } finally {
//       setLoading(false);
//     }
//   };

//   /* ================= ENTER KEY ================= */
//   const handleKeyDown = (e) => {
//     if (e.key === "Enter") {
//       e.preventDefault();
//       fetchDoctors();
//     }
//   };

//   /* ================= SHOW MAP ================= */
//   const showDoctorOnMap = (doctor) => {
//     if (!mapLoaded) {
//       toast.error("Map still loading");
//       return;
//     }

//     setSelectedDoctor(doctor);

//     setTimeout(() => {
//       const mapDiv = document.getElementById(`map-${doctor.id}`);
//       if (!mapDiv) return;

//       const geocoder = new window.google.maps.Geocoder();
//       const address = `${doctor.ClinicAddress}, ${doctor.Locality || ""}`;

//       geocoder.geocode({ address }, (results, status) => {
//         if (status !== "OK" || !results[0]) {
//           toast.error("Location not found");
//           return;
//         }

//         const map = new window.google.maps.Map(mapDiv, {
//           center: results[0].geometry.location,
//           zoom: 15,
//         });

//         new window.google.maps.Marker({
//           map,
//           position: results[0].geometry.location,
//           title: `Dr. ${doctor.First} ${doctor.Last}`,
//         });
//       });
//     }, 150);
//   };

//   /* ================= BOOK APPOINTMENT ================= */
//   const handleBookAppointment = (doctor) => {
//     setBookingDoctor(doctor);
//     setShowBookingModal(true);
//   };

//   const handleCloseBookingModal = () => {
//     setShowBookingModal(false);
//     setBookingDoctor(null);
//   };

//   return (
//     <>
//       <Navbar />
//       <Container fluid className="search-doctor-container py-5">
//         <ToastContainer />

//         {/* SEARCH BAR */}
//         <Row className="justify-content-center mb-4">
//           <Col md={3}>
//             <Form.Control
//               id="locality-input"
//               type="text"
//               placeholder="Enter City"
//               value={locality}
//               onChange={(e) => setLocality(e.target.value)}
//               onKeyDown={handleKeyDown}
//             />
//           </Col>
//           <Col md={7}>
//             <Form.Control
//               type="text"
//               placeholder="Search Doctor by Name or Speciality"
//               value={doctorName}
//               onChange={(e) => setDoctorName(e.target.value)}
//               onKeyDown={handleKeyDown}
//             />
//           </Col>
//           <Col md={1}>
//             <Button onClick={fetchDoctors}>
//               <FontAwesomeIcon icon={faSearch} />
//             </Button>
//           </Col>
//         </Row>

//         {/* RESULTS */}
//         <Row className="justify-content-center">
//           {loading ? (
//             <p className="text-center">Loading doctors...</p>
//           ) : searched && doctors.length === 0 ? (
//             <p className="text-center">No doctors found</p>
//           ) : (
//             doctors.map((doctor) => (
//               <Col md={5} key={doctor.id} className="mb-4">
//                 <Card className="shadow-sm">
//                   <Row className="g-0">
//                     <Col md={4} className="d-flex justify-content-center align-items-center">
//                       <Card.Img
//                         src={doctor.imageUrl || profile}
//                         className="doctor-img"
//                         style={{
//                           width: "120px",
//                           height: "120px",
//                           objectFit: "cover",
//                           borderRadius: "8px",
//                           margin: "10px"
//                         }}
//                       />
//                     </Col>
//                     <Col md={8}>
//                       <Card.Body>
//                         <Card.Title>
//                           Dr. {doctor.First} {doctor.Last}
//                         </Card.Title>
//                         <p><b>Speciality:</b> {doctor.Speciality}</p>
//                         <p><b>Education:</b> {doctor.Education || "N/A"}</p>
//                         <p><b>Clinic:</b> {doctor.ClinicName}</p>
//                         <p><b>Address:</b> {doctor.ClinicAddress}</p>

//                         <div className="d-flex gap-2">
//                           <Button
//                             size="sm"
//                             variant="outline-primary"
//                             onClick={() => showDoctorOnMap(doctor)}
//                           >
//                             <FontAwesomeIcon icon={faMapMarkerAlt} /> View Map
//                           </Button>
//                           <Button
//                             size="sm"
//                             variant="primary"
//                             onClick={() => handleBookAppointment(doctor)}
//                           >
//                             <FontAwesomeIcon icon={faCalendarAlt} /> Book Appointment
//                           </Button>
//                         </div>
//                       </Card.Body>
//                     </Col>
//                   </Row>

//                   {selectedDoctor?.id === doctor.id && (
//                     <div
//                       id={`map-${doctor.id}`}
//                       style={{ height: "300px", marginTop: "10px" }}
//                     />
//                   )}
//                 </Card>
//               </Col>
//             ))
//           )}
//         </Row>
//       </Container>

//       {/* BOOKING MODAL */}
//     // In your SearchDoctor.js file, update the booking modal section:
// {/* BOOKING MODAL */}
// {bookingDoctor && (
//   <BookingModal
//     show={showBookingModal}
//     handleClose={handleCloseBookingModal}
//     doctor={bookingDoctor}
//   />
// )}

//       <Footer />
//     </>
//   );
// }

import React, { useState, useEffect } from "react";
import Navbar from "../../../Patient/components/pages/Navbar";
import { Container, Row, Col, Form, Card, Button, Badge } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faMapMarkerAlt, faCalendarAlt, faClock } from "@fortawesome/free-solid-svg-icons";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import profile from "./image/dp.png";
import "./SearchDoctor.css";
import Footer from "../../../Footer/Footer";
import BookingModal from "./BookingModal";

import { getDatabase, ref, get } from "firebase/database";
import { app } from "../../../Doctor/Firebase/firebase.config";

const database = getDatabase(app);

/* ================= CITY NORMALIZER ================= */
const normalizeCity = (text = "") =>
  text.toLowerCase().split(",")[0].trim();

export default function SearchDoctor() {
  const [doctors, setDoctors] = useState([]);
  const [locality, setLocality] = useState("");
  const [doctorName, setDoctorName] = useState("");
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [mapLoaded, setMapLoaded] = useState(false);
  const [showBookingModal, setShowBookingModal] = useState(false);
  const [bookingDoctor, setBookingDoctor] = useState(null);
  const [doctorSchedules, setDoctorSchedules] = useState({}); // Store schedules for all doctors

  /* ================= LOAD GOOGLE MAPS ================= */
  useEffect(() => {
    if (window.google && window.google.maps) {
      setMapLoaded(true);
      return;
    }

    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&libraries=places&loading=async`;
    script.async = true;
    script.defer = true;
    script.onload = () => setMapLoaded(true);
    script.onerror = () => toast.error("Google Maps failed to load");

    document.head.appendChild(script);
  }, []);

  /* ================= SAFE AUTOCOMPLETE ================= */
  useEffect(() => {
    if (!mapLoaded) return;

    let retry;

    const initAutocomplete = () => {
      if (
        window.google &&
        window.google.maps &&
        window.google.maps.places
      ) {
        const input = document.getElementById("locality-input");
        if (!input) return;

        const autocomplete =
          new window.google.maps.places.Autocomplete(input, {
            types: ["(cities)"],
            componentRestrictions: { country: "in" },
          });

        autocomplete.addListener("place_changed", () => {
          const place = autocomplete.getPlace();
          setLocality(place.formatted_address || place.name || "");
        });
      } else {
        retry = setTimeout(initAutocomplete, 100);
      }
    };

    initAutocomplete();
    return () => clearTimeout(retry);
  }, [mapLoaded]);

  /* ================= FETCH DOCTOR SCHEDULES ================= */
  const fetchDoctorSchedules = async (doctorIds) => {
    const schedules = {};
    
    for (const doctorId of doctorIds) {
      try {
        const scheduleRef = ref(database, `doctor/${doctorId}/schedule`);
        const scheduleSnapshot = await get(scheduleRef);
        
        if (scheduleSnapshot.exists()) {
          const scheduleData = scheduleSnapshot.val();
          const scheduleKey = Object.keys(scheduleData)[0];
          if (scheduleKey) {
            schedules[doctorId] = scheduleData[scheduleKey];
          }
        }
      } catch (error) {
        console.error(`Error fetching schedule for doctor ${doctorId}:`, error);
      }
    }
    
    setDoctorSchedules(schedules);
  };

  /* ================= FETCH DOCTORS ================= */
  const fetchDoctors = async () => {
    const searchName = doctorName.trim().toLowerCase();
    const searchCity = normalizeCity(locality);

    if (!searchName && !searchCity) {
      toast.warning("Please enter doctor name or locality");
      return;
    }

    try {
      setLoading(true);
      setSearched(true);

      const doctorsRef = ref(database, "doctor");
      const snapshot = await get(doctorsRef);

      if (!snapshot.exists()) {
        setDoctors([]);
        return;
      }

      const data = snapshot.val();

      const allDoctors = Object.keys(data).map((key) => ({
        id: key,
        ...data[key],
      }));

      const filtered = allDoctors.filter((doctor) => {
        const first = doctor.First?.toLowerCase() || "";
        const last = doctor.Last?.toLowerCase() || "";
        const speciality = doctor.Speciality?.toLowerCase() || "";

        const doctorCity = normalizeCity(doctor.Locality);
        const doctorAddress =
          doctor.ClinicAddress?.toLowerCase() || "";

        const nameMatch =
          !searchName ||
          first.includes(searchName) ||
          last.includes(searchName) ||
          speciality.includes(searchName);

        const locationMatch =
          !searchCity ||
          doctorCity.includes(searchCity) ||
          doctorAddress.includes(searchCity);

        return nameMatch && locationMatch;
      });

      setDoctors(filtered);
      
      // Fetch schedules for all found doctors
      const doctorIds = filtered.map(doctor => doctor.id);
      if (doctorIds.length > 0) {
        fetchDoctorSchedules(doctorIds);
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to fetch doctors");
    } finally {
      setLoading(false);
    }
  };

  /* ================= ENTER KEY ================= */
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      fetchDoctors();
    }
  };

  /* ================= SHOW MAP ================= */
  const showDoctorOnMap = (doctor) => {
    if (!mapLoaded) {
      toast.error("Map still loading");
      return;
    }

    setSelectedDoctor(doctor);

    setTimeout(() => {
      const mapDiv = document.getElementById(`map-${doctor.id}`);
      if (!mapDiv) return;

      const geocoder = new window.google.maps.Geocoder();
      const address = `${doctor.ClinicAddress}, ${doctor.Locality || ""}`;

      geocoder.geocode({ address }, (results, status) => {
        if (status !== "OK" || !results[0]) {
          toast.error("Location not found");
          return;
        }

        const map = new window.google.maps.Map(mapDiv, {
          center: results[0].geometry.location,
          zoom: 15,
        });

        new window.google.maps.Marker({
          map,
          position: results[0].geometry.location,
          title: `Dr. ${doctor.First} ${doctor.Last}`,
        });
      });
    }, 150);
  };

  /* ================= BOOK APPOINTMENT ================= */
  const handleBookAppointment = (doctor) => {
    setBookingDoctor(doctor);
    setShowBookingModal(true);
  };

  const handleCloseBookingModal = () => {
    setShowBookingModal(false);
    setBookingDoctor(null);
  };

  /* ================= FORMAT TIME ================= */
  const formatTime = (timeStr) => {
    if (!timeStr) return "Not set";
    
    try {
      const [hours, minutes] = timeStr.split(':').map(Number);
      const ampm = hours >= 12 ? 'PM' : 'AM';
      const displayHours = hours % 12 || 12;
      const displayMinutes = minutes < 10 ? '0' + minutes : minutes;
      return `${displayHours}:${displayMinutes} ${ampm}`;
    } catch (error) {
      return timeStr;
    }
  };

  /* ================= GET DOCTOR SCHEDULE ================= */
  const getDoctorSchedule = (doctorId) => {
    return doctorSchedules[doctorId] || null;
  };

  /* ================= RENDER TIMING BADGE ================= */
  const renderTimingBadge = (doctor) => {
    const schedule = getDoctorSchedule(doctor.id);
    
    if (!schedule) {
      return <Badge bg="secondary" className="me-1">Schedule not set</Badge>;
    }

    const hasMorning = schedule.morningStartTime && schedule.morningEndTime;
    const hasEvening = schedule.eveningStartTime && schedule.eveningEndTime;

    if (hasMorning && hasEvening) {
      return (
        <>
          <Badge bg="info" className="me-1">
            <FontAwesomeIcon icon={faClock} className="me-1" />
            {formatTime(schedule.morningStartTime)} - {formatTime(schedule.morningEndTime)}
          </Badge>
          <Badge bg="warning" className="me-1">
            <FontAwesomeIcon icon={faClock} className="me-1" />
            {formatTime(schedule.eveningStartTime)} - {formatTime(schedule.eveningEndTime)}
          </Badge>
        </>
      );
    } else if (hasMorning) {
      return (
        <Badge bg="info" className="me-1">
          <FontAwesomeIcon icon={faClock} className="me-1" />
          Morning: {formatTime(schedule.morningStartTime)} - {formatTime(schedule.morningEndTime)}
        </Badge>
      );
    } else if (hasEvening) {
      return (
        <Badge bg="warning" className="me-1">
          <FontAwesomeIcon icon={faClock} className="me-1" />
          Evening: {formatTime(schedule.eveningStartTime)} - {formatTime(schedule.eveningEndTime)}
        </Badge>
      );
    } else {
      return <Badge bg="secondary" className="me-1">Timings not set</Badge>;
    }
  };

  /* ================= RENDER TIMING DETAILS ================= */
  const renderTimingDetails = (doctor) => {
    const schedule = getDoctorSchedule(doctor.id);
    
    if (!schedule) {
      return (
        <div className="mt-2">
          <small className="text-muted">
            <FontAwesomeIcon icon={faClock} className="me-1" />
            <strong>Available Timings:</strong> Not specified
          </small>
        </div>
      );
    }

    const hasMorning = schedule.morningStartTime && schedule.morningEndTime;
    const hasEvening = schedule.eveningStartTime && schedule.eveningEndTime;

    if (!hasMorning && !hasEvening) {
      return (
        <div className="mt-2">
          <small className="text-muted">
            <FontAwesomeIcon icon={faClock} className="me-1" />
            <strong>Available Timings:</strong> Not specified
          </small>
        </div>
      );
    }

    return (
      <div className="mt-2">
        <small className="text-muted">
          <FontAwesomeIcon icon={faClock} className="me-1" />
          <strong>Available Timings:</strong>
        </small>
        {hasMorning && (
          <div className="mt-1">
            <Badge bg="light" text="dark" className="me-1">
              <small>🌅 Morning: {formatTime(schedule.morningStartTime)} - {formatTime(schedule.morningEndTime)}</small>
            </Badge>
          </div>
        )}
        {hasEvening && (
          <div className="mt-1">
            <Badge bg="light" text="dark" className="me-1">
              <small>🌇 Evening: {formatTime(schedule.eveningStartTime)} - {formatTime(schedule.eveningEndTime)}</small>
            </Badge>
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      <Navbar />
      <Container fluid className="search-doctor-container py-5">
        <ToastContainer />

        {/* SEARCH BAR */}
        <Row className="justify-content-center mb-4">
          <Col md={3}>
            <Form.Control
              id="locality-input"
              type="text"
              placeholder="Enter City"
              value={locality}
              onChange={(e) => setLocality(e.target.value)}
              onKeyDown={handleKeyDown}
            />
          </Col>
          <Col md={7}>
            <Form.Control
              type="text"
              placeholder="Search Doctor by Name or Speciality"
              value={doctorName}
              onChange={(e) => setDoctorName(e.target.value)}
              onKeyDown={handleKeyDown}
            />
          </Col>
          <Col md={1}>
            <Button onClick={fetchDoctors}>
              <FontAwesomeIcon icon={faSearch} />
            </Button>
          </Col>
        </Row>

        {/* RESULTS */}
        <Row className="justify-content-center">
          {loading ? (
            <p className="text-center">Loading doctors...</p>
          ) : searched && doctors.length === 0 ? (
            <p className="text-center">No doctors found</p>
          ) : (
            doctors.map((doctor) => (
              <Col md={5} key={doctor.id} className="mb-4">
                <Card className="shadow-sm">
                  <Row className="g-0">
                    <Col md={4} className="d-flex justify-content-center align-items-center">
                      <Card.Img
                        src={doctor.imageUrl || profile}
                        className="doctor-img"
                        style={{
                          width: "120px",
                          height: "120px",
                          objectFit: "cover",
                          borderRadius: "8px",
                          margin: "10px"
                        }}
                      />
                    </Col>
                    <Col md={8}>
                      <Card.Body>
                        <Card.Title>
                          Dr. {doctor.First} {doctor.Last}
                          <div className="mt-1">
                            {renderTimingBadge(doctor)}
                          </div>
                        </Card.Title>
                        
                        <p><b>Speciality:</b> {doctor.Speciality}</p>
                        <p><b>Education:</b> {doctor.Education || "N/A"}</p>
                        <p><b>Clinic:</b> {doctor.ClinicName}</p>
                        <p><b>Address:</b> {doctor.ClinicAddress}</p>
                        
                        {/* Show timings in the card */}
                        {renderTimingDetails(doctor)}

                        <div className="d-flex gap-2 justify-content-center mt-3">
                          <Button
                            size="sm"
                            variant="outline-primary"
                            onClick={() => showDoctorOnMap(doctor)}
                          >
                            <FontAwesomeIcon icon={faMapMarkerAlt} /> View Map
                          </Button>
                          <Button
                            size="sm"
                            variant="primary"
                            onClick={() => handleBookAppointment(doctor)}
                          >
                            <FontAwesomeIcon icon={faCalendarAlt} /> Book Appointment
                          </Button>
                        </div>
                      </Card.Body>
                    </Col>
                  </Row>

                  {selectedDoctor?.id === doctor.id && (
                    <div
                      id={`map-${doctor.id}`}
                      style={{ height: "300px", marginTop: "10px" }}
                    />
                  )}
                </Card>
              </Col>
            ))
          )}
        </Row>
      </Container>

      {/* BOOKING MODAL */}
      {bookingDoctor && (
        <BookingModal
          show={showBookingModal}
          handleClose={handleCloseBookingModal}
          doctor={bookingDoctor}
        />
      )}

      <Footer />
    </>
  );
}